import { Briefcase, Building2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { BuyButton } from "./BuyButton";
import { IMAGES } from "./constants";

const PANELS = [
  {
    icon: Briefcase,
    image: IMAGES.workshop,
    alt: "Independent consultant facilitating a client workshop",
    title: "For Consultants, Trainers & Solopreneurs",
    testId: "audience-consultants",
    points: [
      "Launch a new revenue stream — sell workplace civility training to your clients this week, not next quarter",
      "Skip months of program design, research, and slide-building",
      "White-label everything: your logo, your brand, your client relationships",
      "Deliver with the confidence of facilitators who've run this program hundreds of times",
    ],
  },
  {
    icon: Building2,
    image: IMAGES.collaboration,
    alt: "HR team collaborating in a modern office",
    title: "For HR, L&D & Small-Business Leaders",
    testId: "audience-hr",
    points: [
      "Reduce workplace conflict and build a genuine speak-up culture — from the inside out",
      "Ready to roll out in days, without a five-figure consulting engagement",
      "Equip managers and employees with practical bystander intervention language",
      "Train every team, every location, as often as you need — one purchase covers it all",
    ],
  },
];

export const Audiences = () => (
  <section id="who" className="bg-cream-dark py-24 lg:py-32" data-testid="audiences-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">Who it's for</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
          Built for the people who build better workplaces.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {PANELS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <article className="group h-full overflow-hidden rounded-3xl border border-navy/10 bg-white" data-testid={p.testId}>
              <div className="overflow-hidden">
                <img src={p.image} alt={p.alt} className="h-60 w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              </div>
              <div className="p-8 lg:p-10">
                <p.icon className="h-8 w-8 text-terra" aria-hidden="true" />
                <h3 className="mt-4 font-display text-2xl font-bold tracking-tight">{p.title}</h3>
                <ul className="mt-6 space-y-4">
                  {p.points.map((point) => (
                    <li key={point} className="flex items-start gap-3 text-navy/75">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-terra" aria-hidden="true" />
                      <span className="leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-14">
        <BuyButton testId="audiences-buy-button" size="lg">Start Delivering — $249</BuyButton>
      </Reveal>
    </div>
  </section>
);
